"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Strings {
    /* eslint-enable @typescript-eslint/naming-convention */
    /**
     * The `html_special_chars` equivalent to escape
     */
    static escapeHtml(text) {
        if (typeof text === 'number') {
            return text.toString();
        }
        return text.replace(/[&<>"']/g, (match) => Strings.ESCAPE_MAP[match]);
    }
    /**
     * Casts data to boolean, null, number, or json based on data
     */
    static typeCast(data, types = []) {
        if (data === 'true') {
            return true;
        }
        if (data === 'false') { // a
            return false;
        }
        if (data === 'null' || data === null || data === undefined) {
            return null;
        }
        if (data === '') {
            // Only return empty string if explicitly stated the type to be a string
            if (types.length === 0 || types.includes('string') === true) {
                return data;
            }
            // Return null if explicitly stated not to be a string
            // This tackles empty attributes on HTML elements that you would expect to be another type than string
            return null;
        }
        if (types.includes('string') === false && data === +data + '') {
            // Only convert to a number if it doesn't change the string
            // and if explicitly stated not to be a string
            return +data;
        }
        if (Strings.RIGHT_BRACE.test(data)) {
            return JSON.parse(data);
        }
        return data;
    }
    /**
     * Return the first not null and not undefined argument, and cast to string
     */
    static coalesce(...args) {
        for (const argument of args) {
            if (argument !== null && argument !== undefined) {
                return String(argument);
            }
        }
        return '';
    }
    /**
     * transform name from kebab-case to camelCase
     */
    static kebabToCamelCase(string) {
        return string.replace(/(-[a-z])/ig, $1 => $1.toUpperCase().replace('-', ''));
    }
    /**
     * transform name from kebab-case to camelCase
     */
    static camelToKebabCase(string) {
        return string.replace(/([A-Z])/g, $1 => '-' + $1.toLowerCase());
    }
    /**
     * Transform null, undefined or empty string null. Otherwise keep the value.
     */
    static notEmptyOrNull(string) {
        if (string === null || string === undefined || string === '') {
            return null;
        }
        return string;
    }
    /**
     * Replace all occurrences of `search` with `replace` in `string`
     */
    static replaceAll(string, search, replace) {
        return string.replace(new RegExp(Strings.pregQuote(search), 'g'), replace);
    }
    /**
     * Escape string to be used inside RegExp
     */
    static pregQuote(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    /**
     * removes a prefix from a string
     */
    static removePrefix(stringWithPrefix, prefix) {
        return stringWithPrefix.startsWith(prefix) ? stringWithPrefix.replace(new RegExp('^' + prefix), '') : stringWithPrefix;
    }
}
Strings.RIGHT_BRACE = /^(?:{[\w\W]*}|\[[\w\W]*])$/;
/* eslint-disable @typescript-eslint/naming-convention */
Strings.ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
};
exports.default = Strings;
//# sourceMappingURL=Strings.js.map